export default {
  "translation": {
    "card_application": "تطبيق البطاقة",
    "card_application_des": "احصل على بطاقة Sonic واستخدمها في أكثر من 44 مليون تاجر مفعل بفيزا في جميع أنحاء العالم.",
    "spend_your_crypto_like_fiat": "أنفق العملات المشفرة الخاصة بك مثل النقد",
    "use_globally_across_borders": "استخدمها عالميًا، عبر الحدود",
    "ultra_low_trans_costs": "تكاليف المعاملات المنخفضة للغاية",
    "seamless_and_secure": "سهلة وآمنة",
    "two_factor_verification": "التحقق ثنائي العوامل",
    "two_factor_verification_des": "قم بتسجيل الدخول بأمان باستخدام البريد الإلكتروني، الهاتف، البيومترية، و/أو تطبيق المصادقة",
    "safety_pin": "رقم التعريف الشخصي",
    "safety_pin_des": "قيّد الوصول إلى المعلومات الخاصة عن طريق إعداد رقم التعريف الشخصي",
    "trans_3ds_verification": "التحقق من 3DS",
    "trans_3ds_verification_des": "وافق على المشتريات قبل معالجتها",
    "additional_security": "أمان إضافي",
    "additional_security_des": "قم بسهولة بإعداد حدود البطاقة وميزات الأمان الأخرى على التطبيق",
    "get_your_redotpay_card_in_steps": "احصل على بطاقة Sonic الخاصة بك في 3 خطوات بسيطة.",
    "get_your_redotpay_card_subtitle": "أنفق العملات المشفرة كما العملات التقليدية: مقبولة لدى أكثر من 44 مليون تاجر يدعم فيزا حول العالم.",
    "continue_key": "استمر",
    "bind_your_mobile_number": "اربط رقم هاتفك المحمول",
    "complete_identity_verification": "أكمل التحقق من الهوية",
    "apply_a_virtual_or_physical_card": "تقدم بطلب للحصول على بطاقة افتراضية أو مادية",
    "transactions": "المعاملات",
    "need_mobile_bind_confirm": "تحتاج إلى ربط الهاتف أولاً",
    "info": "معلومات",
    "card_trans_status_refund_pending": "استرداد معلق",
    "card_trans_status_refund_success": "استرداد ناجح",
    "card_trans_status_refund_fail": "استرداد فاشل",
    "card_trans_status_refund_wait": "استرداد في الانتظار",
    "card_trans_status_pending": "مصرح به",
    "card_trans_status_cleared": "تم تصفيتها",
    "card_trans_status_declined": "مرفوضة",
    "card_trans_status_canceled": "ملغاة",
    "card_trans_status_refund": "استرداد",
    "card_trans_status_refund_cancel": "إلغاء الاسترداد",
    "refund": "استرداد",
    "transaction_list": "قائمة المعاملات",
    "more": "المزيد",
    "top_questions": "أسئلة شائعة",
    "faq": "الأسئلة الشائعة",
    "self_service": "الخدمة الذاتية",
    "support_center": "مركز الدعم",
    "hello": "مرحبا",
    "updated_on": "تحديث في",
    "chat_with_us": "الدردشة معنا",
    "warning": "تحذير",
    "security_option_change_alert_prompt": "بعد إلغاء الربط/تعديل Google Authenticator/الهاتف/البريد الإلكتروني/رقم التعريف الشخصي، سيتم تعطيل السحب والتحويل الداخلي وسيتم تقييد معاملات البطاقة إلى 1000 دولار أمريكي لكل معاملة خلال الـ 24 ساعة القادمة لأسباب أمنية.",
    "cancel": "إلغاء",
    "ok": "حسناً",
    "account_deletion_regret_promp": "يسمح لك حذف الحساب بفترة ندم مدتها 15 يومًا. عندما تقوم بتسجيل الدخول مرة أخرى خلال 15 يومًا بعد تقديم طلب الحذف، سيتم إلغاء طلبك، وسيستمر استخدام حسابك بشكل طبيعي.",
    "view_on_blockchain_explorer": "عرض على مستكشف البلوكشين",
    "biz_sn": "رقم المعاملة",
    "type": "النوع",
    "create_time": "وقت الإنشاء",
    "logout_confirm": "هل أنت متأكد أنك تريد تسجيل الخروج؟",
    "wallet": "محفظة",
    "continue_with_google": "استمر باستخدام Google",
    "insufficient_balance_deposit_guide": "رصيد غير كافٍ. يرجى إيداع الأصول أو ستُرفض معاملاتك وقد يتم فرض رسوم.",
    "to": "إلى",
    "bill_will_be_sent_to": "سيتم إرسال كشف الحساب إلى",
    "bill_statement": "كشف الحساب",
    "export_bill": "تصدير كشف الحساب",
    "this_month": "هذا الشهر",
    "last_month": "الشهر الماضي",
    "last_3_month": "آخر 3 أشهر",
    "this_year": "هذا العام",
    "last_year": "العام الماضي",
    "customize": "تخصيص",
    "bill_export_success": "تم إرسال كشف الحساب إلى بريدك الإلكتروني، يرجى التحقق",
    "bill_empty": "كشف الحساب الخاص بك فارغ",
    "channel": "القناة",
    "merchant_country": "دولة التاجر",
    "status": "الحالة",
    "withdraw_detail": "تفاصيل السحب",
    "new_key": "جديد",
    "deposit": "إيداع",
    "withdraw": "سحب",
    "single_limit": "حد فردي",
    "all": "الكل",
    "minimum": "الحد الأدنى",
    "available": "متاح",
    "received_amount": "المبلغ المستلم",
    "withdrawl": "سحب",
    "network_fee": "رسوم الشبكة",
    "register": "تسجيل",
    "register_login": "تسجيل الدخول/التسجيل",
    "login": "تسجيل الدخول",
    "email_Phone": "البريد الإلكتروني/رقم الهاتف",
    "email": "البريد الإلكتروني",
    "mobile": "محمول",
    "next": "التالي",
    "or_continue_with": "أو استمر مع",
    "forgot_pw": "نسيت كلمة المرور؟",
    "welcome_to_redotpay": "مرحبًا بك في Sonic Pay",
    "verify_code": "تحقق من الرمز",
    "get_code": "احصل على الرمز",
    "by_creating_an_account": "عند إنشاء حساب، فإنك توافق على",
    "privacy_policy": "سياسة الخصوصية",
    "terms_conditions": "الشروط والأحكام",
    "and": "و",
    "modify_pin": "تغيير الرقم السري",
    "pin_subtitle": "يوفر رقم التعريف الشخصي تحققًا سريعًا، مما يسهل عليك عرض أرقام البطاقة ومعلومات CVV.",
    "password_set_first_login": "تسجيل الدخول لأول مرة لتعيين كلمة المرور",
    "next_step": "الخطوة التالية",
    "confirm": "تأكيد",
    "username": "اسم المستخدم",
    "password": "كلمة المرور",
    "send_code": "إرسال الرمز",
    "send_code_to": "سيتم إرسال الرمز إلى",
    "switch_option": "تغيير خيار التحقق",
    "mobile_verification": "التحقق عبر الهاتف المحمول",
    "email_verification": "التحقق عبر البريد الإلكتروني",
    "choose_verify_method": "اختر طريقة التحقق",
    "verify_pin": "رقم التعريف الشخصي الأمني",
    "google_authenticator_verification": "التحقق من Google Authenticator",
    "security": "الأمان",
    "bound": "مرتبط",
    "unbound": "غير مرتبط",
    "set": "تعيين",
    "unset": "إلغاء التعيين",
    "update_pw": "تغيير كلمة المرور",
    "delete_account": "إلغاء الحساب",
    "google_authenticator": "Google Authenticator",
    "google_authenticator_subtitle": "يحمي Google Authenticator عمليات السحب وحسابك.",
    "download_install": "تحميل",
    "download_install_prompt": "أولاً، تحتاج إلى تحميل وتثبيت تطبيق المصادقة (Google Authenticator)",
    "backup_key": "مفتاح النسخ الاحتياطي",
    "save_backup_key": "احفظ مفتاح النسخ الاحتياطي في مكان آمن",
    "google_authenticator_code": "رمز Google Authenticator",
    "email_subtitle": "تحقق البريد الإلكتروني يحمي عمليات السحب وحسابك.",
    "change_email": "تغيير البريد الإلكتروني",
    "email_update": "تحديث البريد الإلكتروني",
    "code": "الرمز",
    "mobile_subtitle": "تحقق الهاتف المحمول يحمي عمليات السحب وحسابك.",
    "change_mobile": "تغيير الهاتف المحمول",
    "mobile_update": "تحديث الهاتف المحمول",
    "mobile_bind": "ربط الهاتف المحمول",
    "email_bind": "ربط البريد الإلكتروني",
    "old_password": "كلمة المرور القديمة",
    "new_password": "كلمة المرور الجديدة",
    "new_password_confirm": "تأكيد كلمة المرور الجديدة",
    "language": "اللغة",
    "appearance": "المظهر",
    "logout": "تسجيل الخروج",
    "log_out_toast": "تم تسجيل خروجك",
    "set_pin": "رقم التعريف الشخصي الأمني",
    "account_deletion_prompt_1": "لن يتم استرداد هذا الحساب أبدًا",
    "account_deletion_prompt_2": "سيتم حذف جميع المستخدمين الفرعيين / الحسابات الأخرى التي تم إنشاؤها بواسطة هذا الحساب ولا يمكن استردادها.",
    "account_deletion_prompt_3": "سيتم حذف جميع مفاتيح API المرتبطة بهذا الحساب.",
    "account_deletion_prompt_4": "سيتم إلغاء جميع السحوبات الحالية والمعلقة من هذا الحساب.",
    "account_deletion_prompt_5": "سيتم تعطيل جميع وظائف المعاملات لهذا الحساب.",
    "account_deletion_prompt_6": "ستعتبر الأصول التي لم يتم سحبها من هذا الحساب كأصول تم التخلي عنها طواعية.",
    "account_deletion_prompt_7": "بعد تقديم طلب حذف الحساب، يمكنك الاستفادة من فترة سحب مدتها 15 يومًا. عندما تسجل الدخول مرة أخرى خلال 15 يومًا بعد طلب الحذف، سيتم إلغاء طلب الحذف الخاص بك ويمكن استخدام الحساب بشكل طبيعي.",
    "kyc_status_0": "لم يتم تقديمه",
    "kyc_status_1": "جاري التحقق...",
    "kyc_status_2": "تمت الموافقة",
    "kyc_status_3": "فشل التدقيق",
    "kyc_status_4": "إعادة التقديم",
    "kyc_status_5": "تقديم إلى المنبع",
    "personal_info_review": "مراجعة المعلومات الشخصية",
    "additional_info_request": "طلب معلومات إضافية",
    "verifying": "جاري التحقق...",
    "form_submitted_will_review_asap_new": "تم تقديم طلبك للمراجعة اليدوية. عادة ما تستغرق العملية 3-5 أيام، ولكن قد تستغرق أحيانًا وقتًا أطول. يرجى التحلي بالصبر.",
    "get_verified": "التحقق من الهوية",
    "kyc_verified": "تم التحقق من هوية المستخدم",
    "approved": "موافق عليه",
    "not_able_to_submit_identity": "كجزء من عملية المراجعة الشاملة لدينا، نحتاج إلى معلومات إضافية منك لإكمال إجراءات التحقق من الهوية (KYC) ومكافحة غسيل الأموال (AML).",
    "aml_review_failed": "للمضي قدمًا في طلبك، يرجى النقر على الزر أدناه للوصول إلى وإكمال نموذج الإقرار الذاتي.",
    "aml_declaration_prompt": "يرجى ملاحظة أن عدم تقديم النموذج المطلوب خلال الـ 14 يومًا القادمة سيؤدي إلى رفض طلبك.",
    "verify_your_identity": "تحقق من هويتك",
    "get_identity_verified": "تحقق من هويتك لشراء واستخدام البطاقة",
    "country_region": "البلد/المنطقة",
    "given_name": "الاسم الأول",
    "surname": "اسم العائلة",
    "date_of_birth": "تاريخ الميلاد",
    "document_type": "نوع الوثيقة",
    "document_number": "رقم الوثيقة",
    "given_name_intl": "الاسم الأول (دولي)",
    "surname_intl": "اسم العائلة (دولي)",
    "click_to_add_signature": "انقر لإضافة توقيع",
    "rewrite": "إعادة كتابة",
    "submit": "تقديم",
    "save": "حفظ",
    "accounts_are_not_available": "الحسابات غير متاحة",
    "abandon_assets": "التخلي عن أصول بقيمة {{amount}} {{currency}}",
    "account_deletion_successful": "تم حذف الحساب بنجاح",
    "passwords_do_not_match": "كلمات المرور لا تتطابق",
    "password_reset_success": "تمت إعادة تعيين كلمة المرور بنجاح",
    "password_confirm": "تأكيد كلمة المرور",
    "is_refund": "استرداد",
    "total_debt": "إجمالي الدين",
    "your_account_is_in_arrears": "حسابك متأخر. يرجى إيداع أموال كافية لتسوية الرصيد. سيتم استعادة حسابك/بطاقتك عندما يصبح رصيدك ≥10 دولار أمريكي بعد سداد الدين.",
    "repayment": "سداد",
    "debit_record": "سجل الخصم",
    "no_data": "بيانات فارغة",
    "payment": "دفع",
    "transaction_details": "تفاصيل المعاملة",
    "transaction_date": "تاريخ المعاملة",
    "transaction_id": "رقم المعاملة",
    "view_linked_order": "عرض الطلب المرتبط",
    "rights_interests": "الحقوق والمصالح",
    "transaction_limit": "حد المعاملة",
    "deposit_withdraw": "إيداع وسحب",
    "card_purchased_number": "عدد البطاقات المتاحة للشراء",
    "on_review_your_applicant": "نحن نقوم بمراجعة طلبك",
    "form_en_only": "يمكن ملء النموذج باللغة الإنجليزية فقط",
    "available_to_spend": "متاح للإنفاق",
    "get_a_card": "احصل على بطاقة Sonic واستخدمها في أكثر من 44 مليون تاجر مفعل بفيزا في جميع أنحاء العالم.",
    "virtual_card": "بطاقة افتراضية",
    "physical_card": "بطاقة مادية",
    "apply_card": "تقدم بطلب للحصول على بطاقة",
    "enjoy_seamless_spending": "استمتع بإنفاق سلس",
    "spend_and_withdraw": "إنفاق وسحب من أجهزة الصراف الآلي",
    "card_labeling": "وسم البطاقة",
    "card_tag": "علامة البطاقة",
    "edit_billing_address": "عنوان الفواتير",
    "government_issued_id": "هوية صادرة عن الحكومة",
    "facial_recognition": "التعرف على الوجه",
    "address": "العنوان",
    "personnel_information_details": "تفاصيل المعلومات الشخصية",
    "nation_list": "قائمة الدول",
    "choose_channel": "وضع التحقق",
    "mobile_channel_sms": "SMS",
    "mobile_channel_smsAliyunWhatsApp": "WhatsAPP",
    "card_application_order": "طلب بطاقة",
    "promo_code_optional": "رمز ترويجي (اختياري)",
    "promo_code": "رمز ترويجي",
    "billing_address": "عنوان الفواتير",
    "shipping_address": "عنوان الشحن",
    "shipping_to": "الشحن إلى",
    "card_purchase_fee": "رسوم شراء البطاقة",
    "card_holder_name": "اسم حامل البطاقة",
    "city": "المدينة",
    "province_state": "المقاطعة/الولاية",
    "postal_code": "الرمز البريدي",
    "address_line1": "العنوان",
    "address_line2": "عنوان 2",
    "please_fill_in_the_information_in_english": "يمكن ملء النموذج باللغة الإنجليزية فقط",
    "first_name": "الاسم الأول",
    "last_name": "اسم العائلة",
    "country_code": "رمز الدولة",
    "card_application_list": "قائمة طلبات البطاقة",
    "buy_virtual_card": "اشترِ بطاقة افتراضية",
    "buy_physical_card": "اشترِ بطاقة مادية",
    "withdraw_list": "قائمة السحب",
    "no_more_data": "لا توجد بيانات إضافية",
    "select_a_network": "اختر شبكة",
    "please_select_network": "يرجى اختيار شبكة",
    "select_a_network_ensure": "تأكد من أن الشبكة التي اخترتها للإيداع تتطابق مع شبكة السحب، أو قد تضيع الأصول.",
    "network": "الشبكة",
    "card_management": "إدارة البطاقة",
    "freeze": "تجميد",
    "unfreeze": "إلغاء التجميد",
    "freeze_card_des": "بمجرد تمكين وظيفة قفل البطاقة ذات الزر الواحد، لن تتمكن من استخدام هذه البطاقة، ولكن لن يؤثر ذلك على بطاقات أخرى. إذا كنت ترغب في إلغاء وظيفة قفل البطاقة، يمكنك تفعيلها مرة أخرى هنا",
    "freezing_trades": "تجميد البطاقة ينتج عنه طلب فاشل، مما يؤدي إلى فشل المعاملة أو رسوم إضافية للمعاملات المرفوضة",
    "unfreeze_your_card_desc": "بمجرد تعطيل وظيفة قفل البطاقة ذات الزر الواحد، ستتمكن من استخدام هذه البطاقة مرة أخرى، ولن يؤثر ذلك على بطاقات أخرى. إذا كنت ترغب في تجميد البطاقة، يمكنك القيام بذلك هنا مرة أخرى",
    "card_tag_set_success": "تم تعيين علامة البطاقة بنجاح",
    "bill": "فاتورة",
    "setting": "الإعدادات",
    "limit": "الحد",
    "assets_list": "قائمة الأصول",
    "empty_data": "بيانات فارغة",
    "deposit_list": "قائمة الإيداع",
    "date": "التاريخ",
    "merchant_city": "مدينة التاجر",
    "card_number": "رقم البطاقة",
    "card_type": "نوع البطاقة",
    "mcc": "MCC",
    "declined_reason": "سبب الرفض",
    "card_authorization_payment": "دفع تفويض البطاقة",
    "declined_transaction_fee": "رسوم المعاملة المرفوضة",
    "verified": "محقق",
    "notifications": "الإشعارات",
    "need_to_add_bill_address": "تحتاج إلى إضافة عنوان الفواتير",
    "need_to_add_shipping_address": "لا يمكن أن تكون عنوان الشحن فارغًا",
    "success": "نجاح",
    "welcome_redotpay": "مرحبًا بك في Sonic Pay!",
    "reset_pw_alert": "بعد تغيير كلمة المرور، سيتم تعطيل السحب والتحويل الداخلي وسيتم تقييد معاملات البطاقة إلى 1000 دولار أمريكي لكل معاملة خلال الـ 24 ساعة القادمة لأسباب أمنية.",
    "no_more_records": "لا توجد سجلات إضافية",
    "add": "إضافة",
    "address_label": "علامة العنوان",
    "add_address": "إضافة عنوان",
    "this_field_is_required": "هذا الحقل مطلوب",
    "ID_CARD": "بطاقة الهوية",
    "PASSPORT": "جواز السفر",
    "DRIVERS": "رخصة القيادة",
    "RESIDENCE_PERMIT": "تصريح الإقامة",
    "amount": "المبلغ",
    "withdraw_status_waiting": "في الانتظار",
    "withdraw_status_pending": "معلق",
    "withdraw_status_success": "نجاح",
    "withdraw_status_fail": "فشل",
    "withdraw_status_canceled": "ملغاة",
    "withdraw_status_declined": "مرفوضة",
    "withdraw_status_complete": "مكتمل",
    "order_id": "رقم الطلب",
    "click_or_scroll_to_load_more": "انقر أو مرر لعرض المزيد",
    "minimum_deposit_amount": "حد الإيداع الأدنى",
    "deposit_arrival_confirmations": "وصول الإيداع: {{confirmations}} تأكيدات",
    "confirmations": "{{confirmations}} تأكيدات",
    "deposit_network": "شبكة الإيداع",
    "minimum_deposit": "حد الإيداع الأدنى",
    "deposit_arrival": "وصول الإيداع",
    "current_address_supports_depositing": "العنوان الحالي يدعم فقط إيداع {{varietyCode}} على {{displayName}}، وأي أصول أخرى ستضيع.",
    "copy_successful": "تم النسخ بنجاح",
    "update_password_successful": "تحديث كلمة المرور بنجاح",
    "update_successful": "تم التحديث بنجاح",
    "successful": "ناجح",
    "signature_required": "التوقيع مطلوب",
    "deposit_successful": "تم الإيداع بنجاح",
    "sign_out": "تسجيل الخروج",
    "cancel_withdraw_order_success": "تم إلغاء طلب السحب بنجاح",
    "delete_successful": "تم الحذف بنجاح",
    "unfreeze_card_successful": "تم إلغاء تجميد البطاقة بنجاح",
    "card_nickname_set_successful": "تم تعيين اللقب للبطاقة بنجاح",
    "trans_limit_adjusted_success": "تم ضبط حد المعاملة بنجاح",
    "set_card_pin_success": "تم تعيين رقم تعريف البطاقة بنجاح",
    "withdraw_apply_commit_please_wait": "تم تقديم طلب السحب، يرجى الانتظار",
    "unfreeze_success": "تم إلغاء التجمد بنجاح",
    "freeze_success": "تم التجمد بنجاح",
    "withdraw_duration_tip": "سيتم معالجة طلبات السحب خلال يوم عمل واحد",
    "you_will_withdraw": "سوف تسحب",
    "withdraw_info": "معلومات السحب",
    "please_confirm_same_network": "تأكد من أن الشبكة التي اخترتها للإيداع تتطابق مع شبكة الإيداع، وإلا قد تضيع الأصول.",
    "cancel_withdraw_order_confirm": "هل أنت متأكد أنك تريد إلغاء السحب؟",
    "valid_thru": "صالح حتى",
    "last_7_days": "آخر 7 أيام",
    "last_30_days": "آخر 30 يومًا",
    "today": "اليوم",
    "all_done": "تمت جميع العمليات",
    "view_details": "عرض التفاصيل",
    "withdraw_success": "تم السحب بنجاح",
    "pay": "دفع",
    "fee": "رسوم",
    "discount": "خصم",
    "price": "سعر",
    "card_application_details": "تفاصيل طلب البطاقة",
    "card_pin": "رقم تعريف البطاقة",
    "card_pin_format_helper": "لا يمكن أن يحتوي على ثلاثة أرقام متطابقة متتالية أو أرقام متسلسلة",
    "digit_variable": "{{count}} رقم",
    "address_book": "دليل العناوين",
    "unlimited": "غير محدود",
    "single": "واحد",
    "update_card_pin": "تحديث رقم تعريف البطاقة",
    "set_card_pin": "تعيين رقم تعريف البطاقة",
    "report_lost": "الإبلاغ عن فقدان",
    "report_lost_card": "الإبلاغ عن بطاقة مفقودة",
    "card_lost_report_alert": "بعد الإبلاغ عن فقدان البطاقة، سيتم تعطيل البطاقة ولن تتمكن من تغيير الحالة. إذا كنت ترغب في استخدام البطاقة مرة أخرى أو التقدم للحصول على بطاقة جديدة، يرجى الاتصال بفريق خدمة العملاء.",
    "pending": "معلق",
    "frozen": "مجمد",
    "phone_number": "رقم الهاتف",
    "search": "بحث",
    "reset": "إعادة تعيين",
    "total_amount": "المبلغ الإجمالي",
    "actual_amount": "المبلغ الفعلي",
    "already_have_an_account": "هل لديك حساب بالفعل؟",
    "create_account": "إنشاء حساب Sonic Pay",
    "total_balance": "الرصيد الكلي",
    "cards_balance_available_promp": "حد الائتمان محسوب في الوقت الفعلي بناءً على أصول المحفظة",
    "got_it": "فهمت",
    "review_details": "مراجعة التفاصيل",
    "delete_this_address": "هل أنت متأكد أنك تريد حذف هذا العنوان؟",
    "currency": "عملة",
    "merchant_name": "اسم التاجر",
    "request_time": "وقت الطلب",
    "is_transaction_allowed": "هل هذه المعاملة مسموح بها؟",
    "approve": "موافقة",
    "decline": "رفض",
    "card_in_production": "البطاقة قيد الإنتاج",
    "redotpay_card_sent": "تم إرسال بطاقة Redotpay",
    "redotpay_card_activated": "تم تفعيل بطاقة Redotpay",
    "activate_card": "تفعيل البطاقة",
    "paste": "لصق",
    "fees_included": "الرسوم المتضمنة",
    "fx_fee": "رسوم الصرف الأجنبي",
    "small_auth_fee": "رسوم المعاملة الصغيرة",
    "atm_fee": "رسوم الصراف الآلي",
    "received": "تلقى",
    "incremental": "الزيادات",
    "bill_address_save_success": "نجاح حفظ عنوان الفاتورة",
    "no_more_trans_record": "لا مزيد من سجلات المعاملات",
    "something_error": "حدث خطأ",
    "home": "الصفحة الرئيسية",
    "select_country": "اختر البلد",
    "billing_list": "قائمة الفواتير",
    "coupon_code": "رمز الخصم",
    "password_rule1": "8 حتى 32 حرف",
    "password_rule2": "حرف كبير أنجليزي واحد على الأقل",
    "password_rule3": "حرف صغير أنجليزي واحد على الأقل",
    "password_rule4": "رقم واحد على الأقل",
    "payment_currency_settings": "إعدادات عملة الدفع",
    "customize_payment_currency": "تخصيص عملة الدفع",
    "disable_non_local_tip": "تعطيل المعاملات بالعملات غير المحلية يمكن أن يقلل بشكل فعال من مخاطر الاحتيال على البطاقات",
    "charging_rules": "قواعد الشحن",
    "reissue_card": "إعادة إصدار البطاقة",
    "update_cvv": "تحديث رمز CVV",
    "update_cvv_desc": "نفس رقم البطاقة، رمز CVV جديد وتاريخ انتهاء جديد.",
    "reissue_fee": "رسوم إعادة الإصدار",
    "fx_fee_desc": "تشمل رسوم الصرف الأجنبي (رسوم FX) 1.2٪ رسوم معاملات بعملة غير افتراضية (إذا كان ذلك ممكنًا).",
    "atm_fee_desc": "سيتم فرض رسوم إضافية بنسبة 2٪ لكل عملية سحب من أجهزة الصراف الآلي.",
    "remit_fee_desc": "الرسوم لاستخدام بطاقة ائتمان أو خصم Visa.",
    "risk_safety_tips": "نصائح الأمان",
    "risk_safety": "لأسباب أمنية، يرجى إكمال التحقق من التعرف على الوجه في التطبيق قبل متابعة أي عمليات ذات صلة.",
    "go_to_app_verify": "اذهب إلى التطبيق للتحقق",
    "register_download_app_title": "Sonic card service is ending. If you're a Sonic cardholder, you can get a free virtual card when you switch to RedotPay.",
    "register_download_app_desc": "Starting today, new registrations for the Sonic card, card issuance, and deposits are no longer available.\n\nFrom <bold>September 15, 2026</bold>, Sonic cards can no longer be used for transactions.\n\nWe've arranged so that you can continue your card services with RedotPay. <bold>Just register using the same email address linked to your Sonic account.</bold>\n\nIf you have a Sonic card, you'll get a free virtual RedotPay card once the move is complete.",
    "get_your_free_card": "Get your free card",
    "register_download_app_title_ended": "Sonic card services have now moved to RedotPay. If you're a Sonic cardholder, you can get a free virtual card when you register with RedotPay.",
    "register_download_app_desc_ended": "Starting today, new registrations for the Sonic card, card issuance, and deposits are no longer available.\n\nFrom <bold>September 15, 2026</bold>, Sonic cards can no longer be used for transactions.\n\nWe've arranged so that you can continue your card services with RedotPay. <bold>Just register using the same email address linked to your Sonic account.</bold>\n\nIf you have a Sonic card, you'll get a free virtual RedotPay card once the move is complete.",
    "go_to_redotpay": "Go to RedotPay",
    "go_to_redotpay_now": "انتقل إلى RedotPay الآن",
    "close": "إغلاق",
    "card_cancellation": "إلغاء البطاقة",
    "delete_card": "حذف البطاقة",
    "delete_card_desc": "لن تكون البطاقة قابلة للاستخدام بعد الحذف، وهذه العملية لا يمكن التراجع عنها.",
    "deleting_fee": "رسوم الحذف",
    "currency_tips": "نصائح العملات",
    "at_least_one_currency": "يرجى الاحتفاظ بعملة واحدة على الأقل قابلة للدفع.",
    "all_select_currency": "أنت تدعم جميع العملات بالفعل لإكمال المعاملات.",
    "small_auth_transaction_fee_stas": "تفاصيل رسوم المعاملات الصغيرة",
    "small_transactions_this_month": "المعاملات الصغيرة هذا الشهر",
    "small_autn_trans_remain": "عدد المعاملات الصغيرة المعفاة من الرسوم هذا الشهر",
    "rules": "القواعد",
    "failed_rules": "ستؤدي المعاملات الفاشلة إلى زيادة عدد سجلات المعاملات السيئة، وستتم إضافة رسوم إضافية إذا تجاوزتها. يرجى تنظيم المعاملة.",
    "rule_item": "البند",
    "free_count": "عدد المرات المجانية",
    "fees": "الرسوم",
    "declined_trans_remain": "عدد المعاملات المرفوضة المعفاة من الرسوم هذا الشهر",
    "declined_transaction_fee_stats": "إحصائيات رسوم المعاملات المرفوضة",
    "declined_rules": "ستؤدي المعاملات الفاشلة إلى زيادة عدد سجلات المعاملات السيئة، وستتم إضافة رسوم إضافية إذا تجاوزتها. يرجى تنظيم المعاملة.",
    "declined_transactions_this_month": "عدد المعاملات المرفوضة هذا الشهر",
    "card_trans_detail_status_refund": "معالجة الاسترداد",
    "card_trans_status_reversal": "عكس",
    "card_trans_status_fully_refund": "تمت المعالجة، تم إصدار استرداد كامل",
    "card_trans_status_partial_refund": "تمت المعالجة، تم إصدار استرداد جزئي",
    "card_trans_status_void": "باطل",
    "first_time_free": "مجاني للمرة الأولى",
    "FxFee": "رسوم الصرف الأجنبي",
    "AtmFee": "رسوم أجهزة الصراف الآلي",
    "RemitFee": "رسوم الحوالات",
    "MccFee": "رسوم MCC",
    "mcc_fee_desc": "سيقوم بعض التجار بفرض رسوم إضافية بنسبة 1.5٪ من مبلغ المعاملة. إذا كانت الرسوم أقل من 0.5 دولار أمريكي، فسيتم تطبيق حد أدنى للرسوم بقيمة 0.5 دولار أمريكي.",
    "please_deposit": "يرجى الإيداع",
    "special_mcc_fee": "رسوم MCC الخاصة",
    "bank_verifying": "يتم مراجعة هذا الاسترداد من قبل البنك…",
    "estimate_time": "الوقت المتوقع للوصول: من 2 إلى 30 يومًا",
    "delete_out": "إلغاء",
    "card_is_loss": "تم الإبلاغ عن فقدان البطاقة",
    "incremental_desc": "إذا كانت المبلغ المصرح به غير كافٍ، سيتم فرض رسوم إضافية، وسيُضاف المبلغ المعني عند التسوية.",
    "card_trans_status_fully_refund1": "تم التسوية",
    "card_trans_status_fully_refund2": "تم رد المبلغ بالكامل",
    "card_trans_status_partial_refund1": "تم التسوية",
    "card_trans_status_partial_refund2": "تم رد جزء من المبلغ",
    "review_takes_time": "يستغرق التدقيق حوالي 2 دقائق إلى 24 ساعة.",
    "custom_date_null": "يرجى اختيار تاريخ مخصص",
    "custom_date_error": "يُرجى ضبط وقت الاستعلام الصحيح.",
    "small_trade_fee": "رسوم المعاملة الصغيرة",
    "user_risk_exception": "استثناء حالة المستخدم",
    "request_exception": "خطأ في نتيجة الطلب",
    "mobile_is_not_empty": "يرجى إدخال رقم هاتف صحيح",
    "code_is_not_empty": "يرجى إدخال رمز التحقق الصحيح",
    "browser_paste_error": "قيود المتصفح، الرجاء إدخالها يدويًا"
  }
};